import { handleActions } from 'redux-actions';
import { getData, postData } from '../utils/parkingRequest';

const initialState = {
  address: null,
  cars: [],
};

// const LOAD_ADDRESS = "LOAD_ADDRESS";
const LOAD_CARS = 'LOAD_CARS';
const SUBMIT_COMMENT = 'SUBMIT_COMMENT';

/** ******************* ACTIONS ******************** */

const loadCars = cars => ({
  type: [LOAD_CARS],
  cars,
});

const submitComment = () => ({
  type: [SUBMIT_COMMENT],
});

export const retrieveSchedule = () => dispatch =>
  getData('parking_attendants').then(response => dispatch(loadCars(response.cars)));

export const postComment = newComment => dispatch =>
  postData('parking_attendants_comments', newComment)
    .then(dispatch(submitComment()))
    .then(() => dispatch(retrieveSchedule()))
    .catch(e => console.log(e));

/** ******************* REDUCER ******************** */

export default handleActions(
  {
    // [LOAD_ADDRESS]: (state, { address }) => ({
    //   ...state,
    //   address
    // }),
    [LOAD_CARS]: (state, { cars }) => ({
      ...state,
      cars,
    }),
    [SUBMIT_COMMENT]: state => ({
      ...state,
    }),
  },
  initialState
);



// WEBPACK FOOTER //
// ./src/redux/parkingData.js